import { useQuery } from '@tanstack/react-query';

import apiRuntime from '~/api/runtime';

type UseReplicaLimitsParams = {
  realm: string;
  environment: string;
  token: string;
};

export const useReplicaLimits = ({
  realm,
  environment,
  token
}: UseReplicaLimitsParams) =>
  useQuery({
    queryKey: ['run', 'replicaLimits', realm, environment, token],
    queryFn: async () => {
      const response = await apiRuntime.getReplicaLimits({
        realm,
        environment,
        token
      });
      return response.data;
    }
  });
